module.exports = __webpack_public_path__ + "img/map-enlarge.d2958816.svg";